// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName
// Import and register all your controllers under controllers/*

import {Application} from '@hotwired/stimulus'
import {registerControllers} from 'stimulus-vite-helpers'

const application = Application.start()
const controllers = import.meta.glob('./**/*_controller.js', {eager: true})
registerControllers(application, controllers)
